import BaseExecutor from 'services/sports/default/base-executor';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import {ForcedStackingValidatorBuilder} from 'services/sports/singlegame/validator/forced-stacking-validator-builder';
import {SingleGameValidatorBuilder} from 'services/validations/builders/single-game-validator-builder';

export default class UserAdjustmentsValidatorSinglegameBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            projectedOwnershipForce,
            playersData: {preparedPlayers},
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const singleGameValidatorBuilder = new SingleGameValidatorBuilder({
            exposureMinPropNames: ['exposureMin', 'captain_exposureMin'],
        }).getInterface();
        validator.addSubValidators([singleGameValidatorBuilder]);

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (stacking.isEnabled()) {
            const forcedStackingValidatorBuilder = new ForcedStackingValidatorBuilder().getInterface();
            validator.addSubValidators([forcedStackingValidatorBuilder]);
        }

        return validator;
    }
}
